import { Box, Center, SimpleGrid, Spinner, Stack, Text } from '@chakra-ui/react';

import { PayCalendar } from '@aslanpay/portal-common-lib';

import { format, parseISO } from 'date-fns';

import useFetchAllPayCycles from 'app/hooks/useFetchAllPayCycles';

import { derivePaySchedule } from 'app/utils/payCalendars';

interface PayScheduleCardProps {
  payCalendar: PayCalendar;
}

const formatDate = (date?: string) => (date ? format(parseISO(date), 'dd MMM yyyy') : '—');

function ScheduleItem({ label, date = undefined }: { label: string; date?: string }) {
  return (
    <Stack spacing="2px">
      <Text textStyle="extraSmallMedium" color="brand.darkGray">
        {label}
      </Text>
      <Text textStyle="h6SemiBold" color="brand.black">
        {formatDate(date)}
      </Text>
    </Stack>
  );
}

function PayScheduleCard({ payCalendar }: PayScheduleCardProps) {
  const { data, isLoading } = useFetchAllPayCycles(payCalendar.id);

  const { lastPayday, nextPayday, lastCutoffDate, nextCutoffDate } = derivePaySchedule(data?.list);

  return (
    <Box border="1px solid" borderColor="brand.lightGray1" borderRadius="10px" p="20px">
      <Text as="h6" textStyle="h6SemiBold" color="brand.darkPurple" mb="16px">
        {payCalendar.name}
      </Text>

      {isLoading ? (
        <Center py="20px">
          <Spinner color="brand.purple" size="md" />
        </Center>
      ) : (
        <SimpleGrid columns={2} spacingX="40px" spacingY="16px">
          <ScheduleItem label="Last pay day" date={lastPayday} />
          <ScheduleItem label="Next pay day" date={nextPayday} />
          <ScheduleItem label="Last cut-off" date={lastCutoffDate} />
          <ScheduleItem label="Next cut-off" date={nextCutoffDate} />
        </SimpleGrid>
      )}
    </Box>
  );
}

export { PayScheduleCard };

export default PayScheduleCard;
